






















import Vue from "vue";

let background = document.createElement('div')
background.className = 'modal-backdrop fade in'
// if (0) {
//     document.body.appendChild(background)
// } else {
//     document.removeChild(background)
// }

export default Vue.extend({
    props: {
        status: {
            type: Boolean,
            default: false
        },
        header: {
            type: Boolean,
            default: false
        },
        footer: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            menuEl: $("#mainmenu"),
        }
    },
    mounted() {
        this.menuEl.css('z-index', this.status ? 130 : 141)
        document.body.className = this.status ? 'modal-open' : ''
    },
    watch: {
        status() {
            this.menuEl.css('z-index', this.status ? 130 : 141)
            document.body.className = this.status ? 'modal-open' : ''
        }
    },    
    methods: {
        close() {
            this.$emit('close');
        }
    }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/components/Modal.vue